


// import {
//   FETCH_TASK_SUBMISSIONS_REQUEST,
//   FETCH_TASK_SUBMISSIONS_SUCCESS,
//   FETCH_TASK_SUBMISSIONS_FAILURE,
//   UPDATE_TASK_STATUS_REQUEST,
//   UPDATE_TASK_STATUS_SUCCESS,
//   UPDATE_TASK_STATUS_FAILURE,
//   BULK_UPDATE_TASK_STATUS_REQUEST,
//   BULK_UPDATE_TASK_STATUS_SUCCESS,
//   BULK_UPDATE_TASK_STATUS_FAILURE,
// } from "../actions/taskActions";

// const initialState = {
//   taskSubmissions: [],
//   loading: false,
//   error: null,
// };

// export const taskReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case FETCH_TASK_SUBMISSIONS_REQUEST:
//     case UPDATE_TASK_STATUS_REQUEST:
//     case BULK_UPDATE_TASK_STATUS_REQUEST:
//       return { ...state, loading: true, error: null };
//     case FETCH_TASK_SUBMISSIONS_SUCCESS:
//       return { ...state, loading: false, taskSubmissions: action.payload };
//     case UPDATE_TASK_STATUS_SUCCESS:
//     case BULK_UPDATE_TASK_STATUS_SUCCESS:
//       return { ...state, loading: false };
//     case FETCH_TASK_SUBMISSIONS_FAILURE:
//     case UPDATE_TASK_STATUS_FAILURE:
//     case BULK_UPDATE_TASK_STATUS_FAILURE:
//       return { ...state, loading: false, error: action.payload };
//     default:
//       return state;
//   }
// };


// export default taskReducer;



import {
  FETCH_TASK_SUBMISSIONS_REQUEST,
  FETCH_TASK_SUBMISSIONS_SUCCESS,
  FETCH_TASK_SUBMISSIONS_FAILURE,
  UPDATE_TASK_STATUS_REQUEST,
  UPDATE_TASK_STATUS_SUCCESS,
  UPDATE_TASK_STATUS_FAILURE,
  BULK_UPDATE_TASK_STATUS_REQUEST,
  BULK_UPDATE_TASK_STATUS_SUCCESS,
  BULK_UPDATE_TASK_STATUS_FAILURE,
} from "../actions/taskActions";

const initialState = {
  taskSubmissions: {
    items: [],
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
      totalPages: 1,
    },
  },
  loading: false,
  error: null,
};

export const taskReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TASK_SUBMISSIONS_REQUEST:
    case UPDATE_TASK_STATUS_REQUEST:
    case BULK_UPDATE_TASK_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_TASK_SUBMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        taskSubmissions: {
          items: action.payload.data || [],
          pagination: {
            page: action.payload.meta?.currentPage || 1,
            limit: 10,
            total: action.payload.meta?.totalRecords || 0,
            totalPages: action.payload.meta?.totalPages || 1,
          },
        },
      };

    case UPDATE_TASK_STATUS_SUCCESS:
    case BULK_UPDATE_TASK_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case FETCH_TASK_SUBMISSIONS_FAILURE:
    case UPDATE_TASK_STATUS_FAILURE:
    case BULK_UPDATE_TASK_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default taskReducer;
